export default __webpack_public_path__ + "static/broken-down-trend-bar-light-mode-2d50bced6ef20ef39097c85fe2f6e991.png";